
import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useUaPhoneMask } from './useUaPhoneMask';

const ENDPOINT = "https://ai-novation.online/a/big/hs/leads/callmeback";
const HIDDEN_SOURCE = "7acfa778-1655-4ca6-a2a9-6e990ea5e052";
const HIDDEN_THEME = "AI-N Заявка на доп.функционал в приложении ai-nova";

export const useLeadForm = () => {
  const { t } = useTranslation("sidebar");
  const [isOpenForm, setIsOpenForm] = useState(false);
  const [name, setName] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [status, setStatus] = useState(null);

  const phoneMask = useUaPhoneMask();

  // Закрытие по Escape
  useEffect(() => {
    function onKey(e) {
      if (e.key === "Escape") setIsOpenForm(false);
    }
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, []);

  const openForm = () => {
    setStatus(null);
    setName("");
    phoneMask.setPhone("");
    setIsOpenForm(true);
  };

  const closeForm = () => setIsOpenForm(false);

  const validate = () => {
    if (!name.trim()) {
      setStatus({ kind: "error", message: t("validation.empty_name") });
      return false;
    }

    if (!phoneMask.isPhoneValid(phoneMask.phone)) {
      setStatus({
        kind: "error",
        message: t("validation.invalid_phone"),
      });
      return false;
    }

    return true;
  };

  const handleSubmit = async (e) => {
    e && e.preventDefault();
    setStatus(null);
    if (!validate()) return;

    setSubmitting(true);
    try {
      const payload = {
        name: name.trim(),
        tel: phoneMask.phone.trim(),
        source: HIDDEN_SOURCE,
        theme: HIDDEN_THEME,
        skipCheckCapcha: true,
      };

      const res = await fetch(ENDPOINT, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });

      if (!res.ok) {
        let errMsg = `${t("status.server_error")} (${res.status})`;
        try {
          const j = await res.json();
          if (j?.message) errMsg = j.message;
        } catch (_) {}
        throw new Error(errMsg);
      }

      setStatus({ kind: "success", message: t("status.success") });
      setName("");
      phoneMask.setPhone("");
    } catch (err) {
      console.error("Submit error:", err);
      setStatus({ kind: "error", message: err?.message || t("status.error_default") });
    } finally {
      setSubmitting(false);
    }
  };

  return {
    isOpenForm,
    openForm,
    closeForm,
    name,
    setName,
    phoneMask,
    submitting,
    status,
    handleSubmit,
    HIDDEN_SOURCE,
    HIDDEN_THEME,
    t,
  };
};